<template>
  <div class="bio-material-type-select-wrapper">
    <VHeader :modal-button="true" @close-modal="emitClose">
      <template #modal-title>Choose Material Type to Add</template>
    </VHeader>
    <SingleSelectFilter
      id="bio-material-type-select"
      label="Type"
      :multiple="false"
      :get-value="bioMaterialBundles"
      track-by="id"
      text-field="label"
      display-value="Type"
      @update-filter="updateSelectedType"
    />
    <div class="choose-material-action">
      <VButton
        id="bio-material-type-choose"
        :class="selectedType ? 'primary' : 'disabled'"
        @click="emitSelectedType"
        :disabled="!selectedType"
      >
        Next
      </VButton>
    </div>
  </div>
</template>

<script>
import SingleSelectFilter from "@/components/filters/SingleSelectFilter.vue";
import VButton from "@/components/raft/VButton.vue";
import VHeader from "../raft/VHeader.vue";

export default {
  name: "BioMaterialTypeSelect",
  components: { VButton, SingleSelectFilter, VHeader },
  data() {
    return {
      selectedType: null,
    };
  },
  methods: {
    updateSelectedType({ value }) {
      this.selectedType = value;
    },
    emitSelectedType() {
      this.$emit("material-type-selected", this.selectedType);
    },
    emitClose() {
      this.$emit("close-modal");
    },
  },
  props: {
    bioMaterialBundles: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.choose-material-action {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.5rem 0;
}
</style>
